import { POST_CATEGORIES } from  '../../actions/actionTypes'
const initialState = {
    categories: []
  };
export default function (state= initialState, action){
     
    switch(action.type){
        case POST_CATEGORIES:
            console.log('POST_CATEGORIES')
             return{
               ...state,
               categories: action.payload.categories
             }     
        default:
           return state      
    }

}